<template>
  <a-card class="Questiongroup">
    <div style="margin-bottom: 15px" @keyup.enter="getList(1)">
      <a-form-model layout="inline">
        <a-form-model-item label="题目壳名称">
          <a-input placeholder="请输入题目壳名称" :maxLength="20" v-model="search.Name" />
        </a-form-model-item>
        <a-form-model-item label="版本名称">
          <a-input placeholder="请输入版本名称" :maxLength="20" v-model="search.versionName" />
        </a-form-model-item>
        <a-form-model-item label="能力维度">
          <a-cascader v-model="selectId" :options="options" :load-data="loadData" placeholder="请选择能力维度" change-on-select @change="onChange" />
        </a-form-model-item>
        <a-form-model-item label="年龄段">
          <a-input-group compact>
            <a-input-number style="width: 100px; text-align: center" placeholder="最小年龄" type="number" :precision="0" :min="1" :max="150" v-model="search.minAge" />
            <a-input style="width: 30px; border-left: 0; pointer-events: none; backgroundcolor: #fff" placeholder="~" disabled />
            <a-input-number style="width: 100px; text-align: center; border-left: none" placeholder="最大年龄" :precision="0" :min="search.minAge" :max="150" type="number" v-model="search.maxAge" />
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select allowClear v-model="search.Enabled" placeholder="请选择状态" style="width: 198px">
            <a-select-option value="true">启用</a-select-option>
            <a-select-option value="false">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="getList(1)">查询</a-button>
          <a-button style="margin: 0 35px 0 15px" @click="resetSearch()">重置</a-button>
        </a-form-model-item>
        <a-form-model-item v-permission="[settingPath]">
          <a-button @click="addEgame()" type="primary" icon="plus" style="margin-left: 45px">添加题目壳</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div>
      <a-table
        :scroll="{ x: 2300 }"
        :loading="loading"
        :columns="columns"
        rowKey="id"
        :data-source="dataSource"
        @expand="getVersion"
        @expandedRowsChange="expandedRowsChange"
        :expandedRowKeys="tableExpandedRowKeys"
        class="components-table-demo-nested"
        :pagination="{
          current: search.PageIndex,
          pageSize: search.PageSize,
          total: total,
          showSizeChanger: true,
          showLessItems: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: onPageChange,
          onShowSizeChange: onSizeChange,
        }"
      >
        <div slot="contentName" slot-scope="text, record">
          <div class="table_div">
            <a-icon type="exclamation-circle" theme="filled" class="table_icon" v-if="text.abnormalFlag > 0 && text.enabled" />
            {{ text.contentName }}
          </div>
        </div>
        <div slot="abilityTypeName" slot-scope="text">
          <div class="self_td" v-for="item in text.abilitys" :key="item.id">
            {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
            {{ item.secondAbilityName }}
          </div>
        </div>
        <div slot="algorithmCode" slot-scope="text">
          <div class="self_td" v-for="item in text.abilitys" :key="item.id">{{ item.algorithmCode }}</div>
        </div>
        <div slot="sampleSize" slot-scope="text">
          <div class="self_td" v-for="item in text.abilitys" :key="item.id">
            <a-button v-if="item.sampleSize" @click="toNormSetting(text, item)" type="link">
              {{ item.sampleSize }}
            </a-button>
          </div>
        </div>
        <div slot="pushQuestionNum" slot-scope="text, record">
          <span v-if="record.pushQuestionNum == 0">全部</span>
          <span v-else>{{ record.pushQuestionNum }}</span>
        </div>
        <div slot="questionCount" slot-scope="text, record">
          {{ record.questionCount }}
        </div>
        <div slot="endTime" slot-scope="text, record">
          {{ text.finishType === 1 ? '不限时' : text.endTime }}
        </div>
        <div slot="courseCount" slot-scope="text, record">
          {{ record.courseCount }}
        </div>
        <div slot="status" slot-scope="text, record" v-auth="`Content.Questiongroup.Enabled`">
          <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.enabled" @click="StatusChange(record)" />
        </div>
        <div slot="ages" slot-scope="text, record">{{ record.minAge }} - {{ record.maxAge }}</div>
        <div slot="action" slot-scope="text, record" class="action">
          <a @click="edit(record)" v-permission="[settingPath]">
            <a-icon type="edit" />
            编辑
          </a>
          <a-popconfirm title="确定删除？" @confirm="deleteEgame(record)" v-permission="`Content.Questiongroup.Delete`">
            <a class="red" v-permission="`Content.Questiongroup.Delete`">
              <a-icon type="delete" />
              删除
            </a>
          </a-popconfirm>
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-permission="`Content.Questiongroup.Subject`">
                <a @click="question(record)">题目</a>
              </a-menu-item>
              <a-menu-item v-permission="`Content.Questiongroup.Preview`">
                <a @click="viewGame(text)">预览</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="copyQuestionGroup(record)">复制</a>
              </a-menu-item>
              <a-menu-item v-if="$route.path === '/content/ParentingGame/ParentingGame'" v-permission="`Content.Questiongroup.Video`">
                <a @click="associatedVideo(text)">视频</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-table>
    </div>
    <a-modal title="题目管理" :visible="isQuestion" @cancel="handleCancel" :footer="null" width="80%">
      <a-tabs :default-active-key="currentTab" @change="changeTabs">
        <a-tab-pane key="1" tab="题目列表">
          <div class="btns" style="position: relative; margin-bottom: 15px; display: flex; justify-content: space-between">
            <div>
              <a-button type="danger" style="margin-right: 15px" @click="batchDelete()">批量删除</a-button>
              <a-button type="primary" style="margin-right: 15px" @click="addQuestion()">新建题目</a-button>
              <a-button type="primary" style="margin-right: 15px" @click="openImport()">批量添加</a-button>
              <a-button type="primary" :loading="exportQuestLoading" @click="exportQuest(questionGroupId)">下载题目</a-button>
            </div>
            <div>
              <a-popconfirm style="margin-right: 15px" title="是否设置自动排序？" ok-text="确定" cancel-text="取消" @confirm="automaticsorting()">
                <a-button type="primary">自动排序</a-button>
              </a-popconfirm>
            </div>
          </div>
          <a-table
            :row-selection="rowSelection"
            :loading="modalLoading"
            :columns="listColumns"
            :data-source="modalData"
            :rowKey="(record) => JSON.stringify(record)"
            class="components-table-demo-nested"
            :pagination="{
              current: modal.pageIndex,
              pageSize: modal.pageSize,
              total: modal.total,
              showSizeChanger: true,
              showLessItems: true,
              showQuickJumper: true,
              showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
              onChange: onModalChange,
              onShowSizeChange: onModalSizeChange,
            }"
          >
            <div slot="name" slot-scope="text, record">
              <div v-html="record.questionDto.name" class="name"></div>
            </div>
            <div slot="questionType" slot-scope="text, record">
              {{ $data._questionType[record.questionDto.questionType] }}
            </div>
            <div slot="questionGroup" slot-scope="text, record">
              <div>{{ record.questionDto.questionGroup }}</div>
            </div>
            <div slot="abilityTypeText" slot-scope="text, record">
              <div>{{ record.questionDto.abilityTypeText }}</div>
            </div>
            <div slot="firstAbilityText" slot-scope="text, record">
              <div>{{ record.questionDto.firstAbilityText }}</div>
            </div>
            <div slot="secondAbilityText" slot-scope="text, record">
              <div>{{ record.questionDto.secondAbilityText }}</div>
            </div>
            <div slot="version" slot-scope="text, record">
              <div>{{ record.questionDto.version }}</div>
            </div>
            <div slot="degreeOfDifficulty" slot-scope="text, record">
              <div>{{ record.questionDto.degreeOfDifficulty }}</div>
            </div>
            <div slot="displayOrder" slot-scope="text, record">
              <input @blur="tableInputBlurDisplayOrder($event, record)" oninput="if(value.length>3)value=value.slice(0,3)" class="table-input" type="number" :value="record.displayOrder" />
            </div>
            <div slot="operation" slot-scope="text, record">
              <a @click="editQuestion(record)" v-permission="[settingPath]"> 编辑 </a>
              <a-popconfirm style="margin-left: 15px" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="deletequertionconfig(record)">
                <a style="color: #f00">
                  <a-icon type="delete" />
                  删除
                </a>
              </a-popconfirm>
              <a-dropdown style="margin-left: 15px">
                <a class="ant-dropdown-link">
                  更多
                  <a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a class="noClick">关闭分页</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="jumpFun(record)" v-if="(record.questionDto.questionType == 1 || record.questionDto.questionType == 3) && !record.questionItems.some((item) => item.skipQuestionId)"
                      >跳转</a
                    >
                    <a
                      @click="jumpFun(record)"
                      style="color: #13c2c2"
                      v-if="(record.questionDto.questionType == 1 || record.questionDto.questionType == 3) && record.questionItems.some((item) => item.skipQuestionId)"
                      >跳转</a
                    >
                    <a class="noClick" v-if="!(record.questionDto.questionType == 1 || record.questionDto.questionType == 3) && !record.questionItems.some((item) => item.skipQuestionId)">跳转</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="题目配置">
          <div class="m_search" style="margin-bottom: 15px">
            <a-form-model layout="inline">
              <a-form-model-item label="题目名称">
                <a-input placeholder="请输入题目名称" :maxLength="35" v-model.trim="questionSet.name" />
              </a-form-model-item>
              <a-form-model-item label="能力维度">
                <a-cascader v-model="selectId" :options="options" :load-data="loadData" placeholder="请选择能力维度" change-on-select @change="onChangequestionSet" />
              </a-form-model-item>
              <a-form-model-item label="题目分组">
                <a-input placeholder="请输入题目分组" :maxLength="35" v-model="questionSet.questionGroup" @change="(e) => (questionSet.questionGroup = e.target.value.replace(/\s*/g, ''))" />
              </a-form-model-item>
              <a-form-model-item label="题目ID">
                <a-input placeholder="请输入题目ID" :maxLength="35" v-model="questionSet.questionid" @change="(e) => (questionSet.questionid = e.target.value.replace(/\s*/g, ''))" />
              </a-form-model-item>
              <a-form-model-item label="难度系数">
                <!-- <a-input placeholder="请输入难度系数" v-model="questionSet.difficulty"/> -->
                <a-input-number placeholder="请输入难度系数" v-model="questionSet.difficulty" type="number" :min="0" :max="10" :step="0.1" style="width: 175px" />
              </a-form-model-item>
              <a-form-model-item>
                <a-button type="primary" @click="getQuestionsList('search')">查询</a-button>
                <a-button style="margin: 0 35px 0 15px" type="primary" @click="questionSetAdd()">批量添加 </a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
          <a-table
            :row-selection="questionSetSelection"
            :loading="loading"
            :columns="questionSetColumns"
            :data-source="questionSetData"
            :rowKey="(record) => JSON.stringify(record)"
            class="components-table-demo-nested"
            :pagination="{
              current: questionSet.pageIndex,
              pageSize: questionSet.pageSize,
              total: questionSetTotal,
              showSizeChanger: true,
              showLessItems: true,
              showQuickJumper: true,
              showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
              onChange: onquestionSetChange,
              onShowSizeChange: onquestionSetSizeChange,
            }"
          >
            <div slot="name" slot-scope="text, record">
              <div v-html="record.name" class="name"></div>
            </div>
            <div slot="questionType" slot-scope="text, record">
              {{ $data._questionType[record.questionType] }}
            </div>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
    <a-modal title="跳转" :visible="isJump" @cancel="CancelJump" :footer="null" width="100%">
      <div class="jumptop">
        <div class="j_t_item">
          <span>题目名称：</span>
          <div v-html="jumpStr.name"></div>
        </div>
        <div class="j_t_item">
          <ul>
            <li>
              <span>题目类型：</span>
              <em>
                {{ $data._questionType[jumpStr.questionType] }}
              </em>
            </li>
            <li>
              <span>一级能力：</span>
              <em>{{ jumpStr.firstAbilityText }}</em>
            </li>
            <li>
              <span>难度系数：</span>
              <em>{{ jumpStr.degreeOfDifficulty }}</em>
            </li>
          </ul>
        </div>
        <div class="j_t_item">
          <ul>
            <li>
              <span>能力类型：</span>
              <em>{{ jumpStr.abilityTypeText }}</em>
            </li>
            <li>
              <span>二级能力：</span>
              <em>{{ jumpStr.secondAbilityText }}</em>
            </li>
          </ul>
        </div>
      </div>
      <a-table
        :loading="loading"
        :columns="jumpColumns"
        :data-source="jumpData"
        rowKey="id"
        class="components-table-demo-nested"
        :pagination="{
          current: jump.pageIndex,
          pageSize: jump.pageSize,
          total: jumpTotal,
          showSizeChanger: true,
          showLessItems: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: onjumpChange,
          onShowSizeChange: onjumpSizeChange,
        }"
      >
        <div slot="option" slot-scope="text, record">
          {{ record.itemTitle }}
          <img :src="record.itemAttachmentUrl | filterUrl" style="width: 28px; height: 28px" v-if="record.itemAttachmentUrl" />
        </div>
        <div slot="jumpQuestion" slot-scope="text, record">
          <span v-if="record.skipQuestionNo">{{ record.skipQuestionNo }} </span>
          <a style="color: #13c2c2; cursor: pointer" v-if="record.skipQuestionNo && record.skipQuestionId" @click="preview(record)">查看题目</a>
        </div>
        <div slot="operation" slot-scope="text, record">
          <a @click="set(record)">
            <a-icon type="edit" />
            设置
          </a>
          <a-popconfirm v-if="record.skipQuestionNo && record.skipQuestionId" style="margin-left: 15px" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="deleteSet(record)">
            <a style="color: #f00">
              <a-icon type="delete" />
              删除
            </a>
          </a-popconfirm>
        </div>
      </a-table>
    </a-modal>
    <a-modal title="跳转设置" :visible="isJumpSet" @cancel="CanceljumpSet" :footer="null" width="100%">
      <div class="jumptop">
        <div class="j_t_item">
          <span>题目名称：</span>
          <div v-html="jumpStr.name"></div>
        </div>
        <div class="j_t_item">
          <ul>
            <li>
              <span>题目类型：</span>
              <em>
                {{ $data._questionType[jumpStr.questionType] }}
              </em>
            </li>
            <li>
              <span>一级能力：</span>
              <em>{{ jumpStr.firstAbilityText }}</em>
            </li>
            <li>
              <span>难度系数：</span>
              <em>{{ jumpStr.degreeOfDifficulty }}</em>
            </li>
          </ul>
        </div>
        <div class="j_t_item">
          <ul>
            <li>
              <span>能力类型：</span>
              <em>{{ jumpStr.abilityTypeText }}</em>
            </li>
            <li>
              <span>二级能力：</span>
              <em>{{ jumpStr.secondAbilityText }}</em>
            </li>
          </ul>
        </div>
      </div>
      <template>
        <a-table
          :loading="loading"
          :columns="jumpSetColumns"
          :data-source="jumpSetData"
          rowKey="id"
          class="components-table-demo-nested"
          :pagination="{
            current: modal.pageIndex,
            pageSize: modal.pageSize,
            total: jumpSet.total,
            showSizeChanger: true,
            showLessItems: true,
            showQuickJumper: true,
            showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
            onChange: onjumpSetChange,
            onShowSizeChange: onjumpSetSizeChange,
          }"
        >
          <div slot="name" slot-scope="text, record">
            <div v-html="record.questionDto.name" class="name"></div>
          </div>
          <div slot="questionType" slot-scope="text, record">
            {{ $data._questionType[record.questionDto.questionType] }}
          </div>
          <div slot="questionGroup" slot-scope="text, record">
            <div>{{ record.questionDto.questionGroup }}</div>
          </div>
          <div slot="abilityTypeText" slot-scope="text, record">
            <div>{{ record.questionDto.abilityTypeText }}</div>
          </div>
          <div slot="firstAbilityText" slot-scope="text, record">
            <div>{{ record.questionDto.firstAbilityText }}</div>
          </div>
          <div slot="secondAbilityText" slot-scope="text, record">
            <div>{{ record.questionDto.secondAbilityText }}</div>
          </div>
          <div slot="version" slot-scope="text, record">
            <div>{{ record.questionDto.version }}</div>
          </div>
          <div slot="degreeOfDifficulty" slot-scope="text, record">
            <div>{{ record.questionDto.degreeOfDifficulty }}</div>
          </div>
          <div slot="operation" slot-scope="text, record, index">
            <span v-if="record.questionId == questionId">当前题目</span>
            <a-radio :checked="radioIndex === record.id || record.questionId === skipQuestionId" @change="changeRadio(index, record)" v-else></a-radio>
          </div>
        </a-table>
      </template>
      <div class="subBtn">
        <a-button type="primary" @click="subJumpSet()">保存</a-button>
      </div>
    </a-modal>
    <a-modal v-model="isimport" title="批量导入题目" @ok="importOk">
      <template slot="footer">
        <a-button key="back" @click="cancelimportOk">取消</a-button>
        <a-button key="submit" type="primary" :loading="importOkloading" @click="importOk">确定</a-button>
      </template>
      <div class="um-download">
        <h4 class="um-h4">数据模板下载</h4>
        <p align="center">
          <a :href="DownloadTemplate | filterUrl" class="templateDownload">模板下载</a>
        </p>
      </div>
      <div class="um-download">
        <h4 class="um-h4">批量导入题目</h4>
      </div>
      <a-upload-dragger name="file" :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" @change="unploadChange">
        <h4 class="um-upload">上传文件</h4>
        <p class="ant-upload-drag-icon">
          <a-icon type="cloud-upload" />
        </p>
        <p class="ant-upload-text" style="color: #666">点击上传文件，或将文件拖拽到此处</p>
        <p class="ant-upload-hint">（支持扩展名为xlsx文件）</p>
      </a-upload-dragger>
      <a @click="down()" v-if="errorData.length" style="text-align: center; margin: 20px 0; display: block; color: #f00">点击这里下载错误数据</a>
    </a-modal>
    <a-modal v-model="ispreview" title="题目预览" :footer="null" width="40%">
      <!-- 单选题 -->
      <div class="qusetion-box" v-if="qusetionItem.questionType == 1">
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" class="dImg" />
        </div>
        <div class="bottom">
          <ul class="viewUl">
            <li v-for="item in qusetionItem.questionItems" :key="item.id">
              <a-radio disabled></a-radio>
              <span>{{ item.itemTitle }}</span>
              <img :src="item.itemAttachmentUrl | filterUrl" v-if="item.itemAttachmentUrl" />
              <a-icon type="check" v-if="item.isRightChoice" style="margin-left: 10px; font-size: 20px" />
            </li>
          </ul>
        </div>
      </div>
      <!-- 多选题 -->
      <div class="qusetion-box" v-if="qusetionItem.questionType == 2">
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
        <div class="bottom">
          <ul class="viewUl">
            <li v-for="item in qusetionItem.questionItems" :key="item.id">
              <a-checkbox disabled></a-checkbox>
              <span>{{ item.itemTitle }}</span>
              <img :src="item.itemAttachmentUrl | filterUrl" v-if="item.itemAttachmentUrl" />
              <a-icon type="check" v-if="item.isRightChoice" style="margin-left: 10px; font-size: 20px" />
            </li>
          </ul>
        </div>
      </div>
      <!-- 量表题 -->
      <div class="qusetion-box" v-if="qusetionItem.questionType == 3">
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
        <div class="bottom">
          <ul class="viewUl">
            <li v-for="item in qusetionItem.questionItems" :key="item.id">
              <a-radio disabled></a-radio>
              <span>{{ item.itemTitle }}</span>
              <img :src="item.itemAttachmentUrl | filterUrl" v-if="item.itemAttachmentUrl" />
              <a-icon type="check" v-if="item.isRightChoice" style="margin-left: 10px; font-size: 20px" />
            </li>
          </ul>
        </div>
      </div>
      <!-- 矩阵单选 -->
      <div class="qusetion-box" v-if="qusetionItem.questionType == 4">
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
        <div class="bottom">
          <ul class="viewUl">
            <div class="bot_t">
              <li></li>
              <template v-for="item in qusetionItem.questionItems">
                <li v-if="item.itemType == 0" :key="item.id" class="viewpick">
                  <span>{{ item.itemTitle }}</span>
                  <img :src="item.itemAttachmentUrl | filterUrl" v-if="item.itemAttachmentUrl" />
                  <!-- <a-icon type="check" v-if="item.isRightChoice" style="margin-left:10px;font-size:20px;"/> -->
                </li>
              </template>
            </div>
            <div class="bot_b">
              <template v-for="item in qusetionItem.questionItems">
                <li v-if="item.itemType == 1" :key="item.id">
                  <span>{{ item.itemTitle }}</span>
                  <span v-for="el in num"><a-radio disabled></a-radio></span>
                </li>
              </template>
            </div>
            <!-- <template v-for="item in qusetionItem.questionItems" >
                          <li v-if="item.itemType == 1" :key="item.id">
                            <span>{{item.itemTitle}}</span>
                            <a-radio disabled></a-radio>
                            <img :src="item.itemAttachmentUrl" v-if="item.itemAttachmentUrl">
                            <a-icon type="check" v-if="item.isRightChoice" style="margin-left:10px;font-size:20px;"/>
                          </li>
                        </template> -->
          </ul>
        </div>
      </div>
      <!-- 矩阵多选 -->
      <div class="qusetion-box" v-if="qusetionItem.questionType == 5">
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
        <div class="bottom">
          <ul class="viewUl">
            <div class="bot_t">
              <li></li>
              <template v-for="item in qusetionItem.questionItems">
                <li v-if="item.itemType == 0" :key="item.id" class="viewpick">
                  <span>{{ item.itemTitle }}</span>
                  <img :src="item.itemAttachmentUrl | filterUrl" v-if="item.itemAttachmentUrl" />
                  <!-- <a-icon type="check" v-if="item.isRightChoice" style="margin-left:10px;font-size:20px;"/> -->
                </li>
              </template>
            </div>
            <div class="bot_b">
              <template v-for="item in qusetionItem.questionItems">
                <li v-if="item.itemType == 1" :key="item.id">
                  <span>{{ item.itemTitle }}</span>
                  <span v-for="el in num"><a-checkbox disabled></a-checkbox></span>
                </li>
              </template>
            </div>
          </ul>
        </div>
      </div>
      <!-- 矩阵量表 -->
      <div class="qusetion-box" v-if="qusetionItem.questionType == 6">
        题目：
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
        <div class="bottom">
          <ul class="viewUl">
            <div class="bot_t">
              <li></li>
              <template v-for="item in qusetionItem.questionItems">
                <li v-if="item.itemType == 0" :key="item.id">
                  <span>{{ item.itemTitle }}</span>
                  <img :src="item.itemAttachmentUrl | filterUrl" v-if="item.itemAttachmentUrl" />
                </li>
              </template>
            </div>
            <div class="bot_b">
              <template v-for="item in qusetionItem.questionItems">
                <li v-if="item.itemType == 1" :key="item.id">
                  <span>{{ item.itemTitle }}</span>
                  <span v-for="el in num"><a-radio disabled></a-radio></span>
                </li>
              </template>
            </div>
          </ul>
        </div>
      </div>
      <!-- 填空题 -->
      <div class="qusetion-box" v-if="qusetionItem.questionType == 7">
        题目：
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
      </div>
    </a-modal>
    <a-modal title="关联视频" width="40%" :centered="true" v-model="video.visible" :confirm-loading="video.confirmLoading" @cancel="selectVideoHandleCancel" @ok="videoHandleOk">
      <a-spin :spinning="video.spinning">
        <a-form-model ref="videoForm" :model="video.form" :rules="video.rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item label="视频" prop="name">
            <div @click="getVideoList(1)">
              <a-input style="pointer-events: none" v-model="video.form.name" />
            </div>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
    <a-modal title="选择视频" width="60%" :centered="true" v-model="selectVideo.visible" @ok="selectVideoHandleOk">
      <a-form-model layout="inline" :model="selectVideo.form">
        <a-form-model-item label="视频名称">
          <a-input v-model="selectVideo.form.name" placeholder="请输入视频名称" />
        </a-form-model-item>
        <a-form-model-item label="一级能力">
          <a-tree-select
            v-model="selectVideo.form.firstAbilityId"
            :tree-data="abilityAll"
            :replaceFields="{ title: 'name', key: 'id', value: 'id' }"
            treeDefaultExpandAll
            style="width: 180px"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="选择一级能力"
            allow-clear
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="getVideoList(1)" type="primary"> 查询 </a-button>
        </a-form-model-item>
      </a-form-model>
      <a-table
        :columns="selectVideo.videoColumns"
        row-key="id"
        :scroll="{ y: 350 }"
        :row-selection="rowSelectionVideo"
        :pagination="selectVideo.table.tablePagination"
        :loading="selectVideo.table.tableLoading"
        :dataSource="selectVideo.table.tableDataSource"
      >
        <div slot="firstAbilityName" slot-scope="text, record">
          <div v-for="item in record.abilitys" :key="item.id">
            <span v-if="item.firstAbilityName == item.firstAbilityId"></span>
            <span v-else>{{ item.firstAbilityName }}</span>
          </div>
        </div>
      </a-table>
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { GetContentRelevanceByContentId, loadallsel, RelevanceVideo } from '../../../utils/http'
import XLSX from 'xlsx-js-style'

const columns = [
  { title: '题目壳名称', scopedSlots: { customRender: 'contentName' }, fixed: 'left', width: 300 },
  { title: '版本名称', dataIndex: 'versionName', fixed: 'left', width: 100 },
  {
    title: '能力类型',
    class: 'testClass',
    width: 250,
    key: 'abilityTypeName',
    align: 'center',
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  { title: '算分码', class: 'testClass', align: 'center', scopedSlots: { customRender: 'algorithmCode' } },
  { title: '常模样本量', class: 'testClass', align: 'center', scopedSlots: { customRender: 'sampleSize' } },
  { title: '取题数量', scopedSlots: { customRender: 'pushQuestionNum' }, key: 'pushQuestionNum', align: 'center' },
  { title: '题目数量', scopedSlots: { customRender: 'questionCount' }, key: 'questionCount', align: 'center' },
  { title: '结束时长', scopedSlots: { customRender: 'endTime' } },
  { title: '关联课程', scopedSlots: { customRender: 'courseCount' }, align: 'center' },
  {
    title: '年龄段',
    scopedSlots: { customRender: 'ages' },
    align: 'center',
    key: 'createTime',
  },
  {
    title: '状态',
    key: 'status',
    align: 'center',
    scopedSlots: { customRender: 'status' },
  },
  { title: '更新时间', dataIndex: 'updateTime', align: 'center', key: 'updateTime' },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    width: 220,
    scopedSlots: { customRender: 'action' },
    fixed: 'right',
  },
]
const innerColumns = [
  { title: '题目壳版本', dataIndex: 'version', key: 'version' },
  // { title: '描述', dataIndex: 'remark', key: 'remark' },
  { title: '创建时间', dataIndex: 'createTime', key: 'createTime' },
  {
    title: '操作',
    scopedSlots: { customRender: 'operation' },
  },
]
const listColumns = [
  { title: '题目名称', scopedSlots: { customRender: 'name' }, width: 200, ellipsis: true, align: 'center' },
  { title: '题目类型', scopedSlots: { customRender: 'questionType' }, align: 'center' },
  { title: '题目分组', scopedSlots: { customRender: 'questionGroup' }, align: 'center' },
  { title: '能力类型', scopedSlots: { customRender: 'abilityTypeText' }, align: 'center' },
  { title: '一级能力', scopedSlots: { customRender: 'firstAbilityText' }, align: 'center' },
  { title: '二级能力', scopedSlots: { customRender: 'secondAbilityText' }, align: 'center' },
  { title: '版本', scopedSlots: { customRender: 'version' }, align: 'center' },
  { title: '难度系数', scopedSlots: { customRender: 'degreeOfDifficulty' }, align: 'center' },
  { title: '排序', scopedSlots: { customRender: 'displayOrder' }, align: 'center' },
  {
    title: '操作',
    width: 200,
    align: 'center',
    scopedSlots: { customRender: 'operation' },
  },
]
const jumpColumns = [
  { title: '选项', scopedSlots: { customRender: 'option' }, width: 200, ellipsis: true, align: 'center' },
  { title: '分值', dataIndex: 'score', align: 'center' },
  { title: '排序', dataIndex: 'displayOrder', align: 'center' },
  { title: '跳转题目', scopedSlots: { customRender: 'jumpQuestion' }, align: 'center' },
  { title: '操作', align: 'center', scopedSlots: { customRender: 'operation' } },
]
const jumpSetColumns = [
  { title: '题目名称', scopedSlots: { customRender: 'name' }, width: 200, ellipsis: true, align: 'center' },
  { title: '题目类型', scopedSlots: { customRender: 'questionType' }, align: 'center' },
  { title: '能力类型', scopedSlots: { customRender: 'abilityTypeText' }, align: 'center' },
  { title: '一级能力', scopedSlots: { customRender: 'firstAbilityText' }, align: 'center' },
  { title: '二级能力', scopedSlots: { customRender: 'secondAbilityText' }, align: 'center' },
  { title: '版本', scopedSlots: { customRender: 'version' }, align: 'center' },
  { title: '难度系数', scopedSlots: { customRender: 'degreeOfDifficulty' }, align: 'center' },
  { title: '操作', align: 'center', scopedSlots: { customRender: 'operation' } },
]
const questionSetColumns = [
  { title: '题目名称', scopedSlots: { customRender: 'name' }, width: 200, ellipsis: true, align: 'center' },
  { title: '题目类型', scopedSlots: { customRender: 'questionType' }, align: 'center' },
  { title: '题目分组', dataIndex: 'questionGroup', align: 'center' },
  { title: '能力类型', dataIndex: 'abilityTypeText', align: 'center' },
  { title: '一级能力', dataIndex: 'firstAbilityText', align: 'center' },
  { title: '二级能力', dataIndex: 'secondAbilityText', align: 'center' },
  { title: '版本', dataIndex: 'version', align: 'center' },
  { title: '难度系数', dataIndex: 'degreeOfDifficulty', align: 'center' },
]
const videoColumns = [
  { title: '视频名称', dataIndex: 'contentName' },
  { title: '一级能力', scopedSlots: { customRender: 'firstAbilityName' } },
  { title: '视频时长', dataIndex: 'endTime' },
  { title: '备注', dataIndex: 'remark' },
]

const exportColumn = {
  题目名称: 'name',
  题目分组: 'questionGroup',
  题目类型: 'questionType',
  题目版本: 'version',
  题目难度系数: 'degreeOfDifficulty',
  题目能力类型: 'abilityTypeText',
  题目一级能力: 'firstAbilityText',
  题目二级能力: 'secondAbilityText',
  题目备注说明: 'remark',
  题目解析: 'analysis',
  题目附件: 'attachmentUrl',
}

const exportItemColumn = {
  选项标题: 'itemTitle',
  选项分值: 'score',
  是否正确答案: 'isRightChoice',
  显示顺序: 'displayOrder',
  跳转题目编号: 'skipQuestionNo',
  选项附件: 'itemAttachmentUrl',
}

const base26 = (function () {
  var DIGITS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  return function (num) {
    var ret = ''
    do {
      ret = DIGITS.charAt(num % 26) + ret
      num = Math.floor(num / 26)
    } while (num > 0)
    return ret
  }
})()

function stripHtml(html) {
  let tempDiv = document.createElement('div')
  tempDiv.innerHTML = html
  return tempDiv.textContent || tempDiv.innerText || ''
}

export default {
  name: 'Questiongroup',
  data() {
    return {
      exportQuestLoading: false,
      DownloadTemplate: process.env.VUE_APP_TEMPLATE_URL + '/template/excel/Question_Import_Template.xlsx',
      loading: true,
      advanced: false,
      istoggleAdvanced: false, //是否显示展开按钮
      dataSource: [],
      columns,
      innerColumns,
      innerData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      options: [],
      selectId: [],
      search: {
        PageIndex: 1,
        PageSize: 10,
        ContentType: this.$route.path === '/content/ParentingGame' ? 5 : 3,
        Name: '',
        versionName: undefined,
        AbilityTypeId: '',
        FirstAbilityId: '',
        SecondAbilityId: '',
        Enabled: undefined,
        minAge: '',
        maxAge: '',
      },
      statusType: '',
      tableExpandedRowKeys: [], //表格展开的行
      isQuestion: false, //题目管理
      modal: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      modalLoading: false,
      modalData: [],
      conselectedRows: [], //选中数据
      listColumns,
      questionGroupId: this.$route.query.questionGroupId, //题目壳id
      isJump: false, //跳转
      jumpStr: {},
      jump: {
        pageIndex: 1,
        pageSize: 10,
      },
      jumpColumns,
      jumpData: [],
      jumpTotal: 0,
      questionId: '',
      isJumpSet: false, //跳转设置
      jumpSet: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      jumpSetColumns,
      jumpSetData: [],
      radioIndex: -1,
      QuestionItemId: '', //题目选项id
      skipId: '', //题目选项skipId
      skipQuestionId: '',
      jumpSetParams: {},
      isOrder: false, //排序
      inputOrder: 0,
      updateorderId: '',
      deleteList: [],
      isimport: false, //批量导入
      importOkloading: false,
      baseURL: process.env.VUE_APP_API_BASE_URL,
      errorData: [],
      fileList: [],
      file: '',
      // 题目配置
      questionSet: {
        pageIndex: 1,
        pageSize: 10,
        groupId: '',
        status: true,
        questionGroup: '',
        difficulty: '',
        name: '',
        questionid: '',
        AbilityTypeId: '',
        FirstAbilityId: '',
        SecondAbilityId: '',
      },
      questionSetTotal: 0,
      selectquestionSetId: [],
      questionSetData: [],
      questionSetColumns,
      questionSetSelect: [],
      addList: [],
      ispreview: false, //查看题目
      qusetionItem: {},
      num: 0,
      currentTab: '1',
      // 关联视频
      abilityAll: [],
      video: {
        spinning: false,
        visible: false,
        confirmLoading: false,
        selectVideoItem: {},
        form: {
          name: '',
        },
        rules: {
          name: [{ required: true, message: '请选择视频', trigger: 'change' }],
        },
      },
      // 选择视频
      selectVideo: {
        videoColumns,
        visible: false,
        table: tableRelevant.call(this, this.getVideoList),
        selectedRowKeys: [],
        selectedRows: [],
        form: {
          name: undefined,
          firstAbilityId: undefined,
        },
      },
      isGame: false,
      settingPath: '',
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path === '/content/Question/QuestionSeting' && to.query.questionGroupId) {
        vm.isQuestion = true
        vm.getQuestionSetList('question')
      }
    })
  },
  created() {
    this.initRoute()
    this.abilityTypeSelect(0)

    setTimeout(() => {
      this.initSearch()
      this.getList()
    }, 300)
  },
  watch: {
    $route(to, from) {
      this.initRoute(from)
    },
    isimport() {
      if (!this.isimport) {
        this.errorData = []
      }
    },
    isQuestion() {
      if (!this.isQuestion) {
        this.conselectedRows = []
        this.questionSetSelect = []
        ;(this.modal = {
          pageIndex: 1,
          pageSize: 10,
          total: 0,
        }),
          (this.questionSet = {
            pageIndex: 1,
            pageSize: 10,
            groupId: '',
            status: true,
            name: '',
            questionGroup: '',
            difficulty: '',
            questionid: '',
            AbilityTypeId: '',
            FirstAbilityId: '',
            SecondAbilityId: '',
          }),
          (this.currentTab = '1')
      }
    },
    isJumpSet() {
      if (!this.isJumpSet) {
        this.skipQuestionId = sessionStorage.getItem('skipQuestionId')
        // this.skipQuestionId =  ''
        this.radioIndex = -1
        this.jumpSetParams = {}
      }
    },
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.conselectedRows,
        onChange: (selectedRowKeys, selectedRows) => {
          this.conselectedRows = selectedRowKeys
          this.deleteList = this.conselectedRows
          console.log(this.deleteList)
        },
      }
    },
    questionSetSelection() {
      return {
        selectedRowKeys: this.questionSetSelect,
        onChange: (selectedRowKeys, selectedRows) => {
          this.questionSetSelect = selectedRowKeys
          this.addList = this.questionSetSelect
        },
      }
    },
    rowSelectionVideo() {
      return {
        type: 'radio',
        selectedRowKeys: this.selectVideo.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectVideo.selectedRowKeys = selectedRowKeys
          this.selectVideo.selectedRows = selectedRows
        },
      }
    },
  },
  methods: {
    initRoute(from = {}) {
      if (from.path && ['/content/Questiongroup/Questiongroup', '/content/ParentingGame/ParentingGame'].includes(from.path)) {
        this.$router.query = {}
      }
      this.isGame = !!~this.$route.path.indexOf('ParentingGame')
      this.settingPath = this.isGame ? '/content/ParentingGame/ParentingGameStting' : '/content/Questiongroup/QuestiongroupSeting'
      this.search.ContentType = this.$route.path === '/content/ParentingGame/ParentingGame' ? 5 : 3
    },
    async copyQuestionGroup(record) {
      const fm = new FormData()
      fm.append('id', record.id)
      const { data } = await this.$http.copyQuestionGroup(fm)
      record.id = data.data
      this.edit(record)
    },
    async exportQuest(id) {
      const fm = new FormData()
      fm.append('questionGroupId', id)
      this.exportQuestLoading = true
      const { data } = await this.$http.getquestiongroupbyid(fm).catch(() => (this.exportQuestLoading = false))
      try {
        const { data: result } = data
        const questList = result.questionInfoDtos
        const exportData = []
        const keys = Object.assign({}, exportItemColumn, exportColumn)

        const merges = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 10 } }]
        const fillStyle = {
          alignment: {
            horizontal: 'center', // 水平居中
            vertical: 'center', // 垂直居中
          },
          fill: {
            patternType: 'solid',
            fgColor: { rgb: 'eead0e' }, // #cdc673
          },
          font: {
            bold: true,
            sz: 11,
          },
        }

        const exportColumnKeys = Object.keys(exportColumn)
        const exportItemColumnKeys = Object.keys(exportItemColumn)

        const columnTitle = ['题目']
        const columnTitleKeys = [...exportColumnKeys]
        let maxItem = -1
        // const replaceReg = //
        const excludesQuest = ['填空题', '问答题']
        for (let i = 0; i < questList.length; i++) {
          const current = questList[i]
          const currentItem = []
          exportColumnKeys.forEach((key) => {
            let val = current[keys[key]]
            if (keys[key] == 'questionType') {
              val = this.$data._questionType[current.questionType]
              if (!excludesQuest.includes(val)) {
                val = val.replace('题', '')
              }
            }
            if (keys[key] == 'name') {
              val = current.name.replace(/^\<p\>(.*)\<\/p\>$/, '$1')
            }

            return currentItem.push(val)
          })

          current.questionItems.forEach((item, index) => {
            exportItemColumnKeys.forEach((key) => {
              let val = item[keys[key]]
              if (keys[key] == 'isRightChoice') {
                val = item.isRightChoice ? '是' : '否'
              }
              currentItem.push(val)
            })
            if (maxItem < index) {
              columnTitle.push('选项' + (index + 1))
              columnTitleKeys.push(...exportItemColumnKeys)
              merges.push({ s: { r: 0, c: exportItemColumnKeys.length * index + 11 }, e: { r: 0, c: exportItemColumnKeys.length * (index + 1) + 10 } })
              maxItem = index
            }
          })
          exportData.push(currentItem)
        }

        exportData.unshift(columnTitleKeys)
        exportData.unshift(
          columnTitle
            .map((v, i) => {
              if (i == 0) {
                return Array.from({ length: exportColumnKeys.length }, () => v)
              }
              return Array.from({ length: exportItemColumnKeys.length }, () => v)
            })
            .flat(3)
        )
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.aoa_to_sheet(exportData)
        ws['!merges'] = merges
        // 设置数据验证：为 A1 单元格添加下拉列表
        // ws['!dataValidations'] = [
        //   {
        //     sqref: 'A3', // 目标单元格
        //     type: 'list', // 数据验证类型为列表
        //     formula1: '"Option 1,Option 2,Option 3"', // 下拉选项
        //     showDropDown: true, // 显示下拉箭头
        //   },
        // ]
        for (let i = 0; i < exportItemColumnKeys.length * (maxItem + 1) + 12; i++) {
          let fix = ''
          if (i < 26) {
            fix = base26(i)
          } else {
            fix = base26(Math.floor(i / 26) - 1) + base26(i % 26)
          }
          if (i <= 10) {
            fillStyle.fill.fgColor.rgb = 'eead0e'
          } else {
            fillStyle.fill.fgColor.rgb = 'cdc673'
          }
          try {
            ws[`${fix}1`].s = JSON.parse(JSON.stringify(fillStyle))
            ws[`${fix}2`].s = JSON.parse(JSON.stringify(fillStyle))
          } catch {}
        }

        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
        const questionGroupInfo = this.$store.getters['content/getQuestionGroupInfo']()
        XLSX.writeFile(wb, `${questionGroupInfo.contentName}.xlsx`)
      } catch (e) {
        console.error(e)
        this.$message.error('下载失败')
      }
      this.exportQuestLoading = false
    },
    initSearch() {
      this.search.Name = this.$route.query.Name
      this.search.PageIndex = Number(this.$route.query.PageIndex) || 1
      this.search.PageSize = Number(this.$route.query.PageSize) || 10
      this.search.versionName = this.$route.query.versionName
      this.search.Enabled = this.$route.query.Enabled
      this.search.AbilityTypeId = Number(this.$route.query.AbilityTypeId) || undefined
      this.search.FirstAbilityId = Number(this.$route.query.FirstAbilityId) || undefined
      this.search.SecondAbilityId = Number(this.$route.query.SecondAbilityId) || undefined
      this.search.minAge = Number(this.$route.query.minAge) || undefined
      this.search.maxAge = Number(this.$route.query.maxAge) || undefined
      if (this.search.AbilityTypeId) {
        this.selectId = [this.search.AbilityTypeId]
      }
      if (this.search.FirstAbilityId) {
        this.selectId = [this.search.AbilityTypeId, this.search.FirstAbilityId]
      }
      if (this.search.SecondAbilityId) {
        this.selectId = [this.search.AbilityTypeId, this.search.FirstAbilityId, this.search.SecondAbilityId]
      }
    },
    setQuery() {
      const query = {}
      for (const key in this.search) {
        if (this.search[key] && typeof this.search[key] !== 'object') {
          query[key] = this.search[key]
        }
      }
      this.$router.push({ query })
    },
    // 查看题目
    preview(record) {
      this.$http.questionDetail({ id: record.skipQuestionId }).then((res) => {
        this.qusetionItem = res.data.data
        this.ispreview = true
        this.num = record.questionItems.filter((item) => {
          return item.itemType == 0
        })
      })

      return
      this.qusetionItem = record
    },
    // 展开行
    expandedRowsChange(expandedRowKeys) {
      if (expandedRowKeys.length > 1) {
        this.tableExpandedRowKeys = [expandedRowKeys.pop()]
      } else {
        this.tableExpandedRowKeys = expandedRowKeys
      }
    },
    //表格设为默认
    tableChildSetDefault(val, parentVal) {
      this.$message.destroy()
      parentVal.childTableLoading = true
      this.$http
        .updateVersionStatus({
          id: val.id,
          enabled: !val.enabled,
        })
        .then((res) => {
          const { message } = res.data
          parentVal.childTableLoading = false
          this.$message.success(message)
          this.getVersion(true, parentVal)
        })
    },
    viewGame(record) {
      let APIURL = process.env.VUE_APP_API_BASE_URL.replace(/^http(s)?:\/\/(.*?)/, '')
      console.log(APIURL)
      let url = ''
      if (record.versions[0].uri) {
        if (record.versions[0].uri.indexOf('http') < 0) {
          url = 'http://' + record.versions[0].uri
        } else {
          url = record.versions[0].uri
        }
        window.open(url + `?questionGroupId=${record.id}&url=${APIURL}&contentId=${record.id}`)
      } else {
        window.open('')
      }
    },
    // 关联视频
    associatedVideo(val) {
      this.video.selectVideoItem = val
      this.video.visible = true
      this.video.spinning = true
      this.$http
        .GetContentRelevanceByContentId({
          contentId: val.id,
        })
        .then((res) => {
          this.video.spinning = false
          const { data } = res.data
          if (data.length) {
            this.video.form.name = data[0].linkContentName + '             ' + data[0].linkContentAbilityName
            this.selectVideo.selectedRowKeys = [data[0].linkContentId]
            this.selectVideo.selectedRows = [
              {
                id: data[0].linkContentId,
                contentName: data[0].linkContentName,
                firstAbilityName: data[0].linkContentAbilityName,
              },
            ]
          }
        })
    },
    videoHandleOk() {
      this.$refs['videoForm'].validate((valid) => {
        if (valid) {
          const json = {
            contentId: this.video.selectVideoItem.id,
            links: [
              {
                linkContentId: this.selectVideo.selectedRows[0].id,
                relevanceType: 1,
                sortIndex: 1,
              },
            ],
          }
          this.video.confirmLoading = true
          this.$http.RelevanceVideo(json).then((res) => {
            this.video.confirmLoading = false
            const { message } = res.data
            this.$message.success(message)
            this.video.visible = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    selectVideoHandleOk() {
      this.$message.destroy()
      if (!this.selectVideo.selectedRows.length) {
        this.$message.error('请选择视频')
        return
      }
      this.selectVideo.visible = false
      this.video.form.name = this.selectVideo.selectedRows[0].contentName + '             ' + this.selectVideo.selectedRows[0].firstAbilityName
      this.$refs['videoForm'].clearValidate()
    },
    selectVideoHandleCancel() {
      this.video.selectVideoItem = {}
      this.video.form.name = undefined
      this.selectVideo.selectedRowKeys = []
      this.selectVideo.selectedRows = []
    },
    getAbilityAll() {
      this.$http
        .loadallsel({
          isSelect: true,
          abilityType: 0,
        })
        .then((res) => {
          const { data } = res.data
          this.abilityAll = data
        })
    },
    getVideoList(pageIndex) {
      this.getAbilityAll()
      this.selectVideo.visible = true
      const params = {
        pageIndex: pageIndex || this.selectVideo.table.tablePagination.current,
        pageSize: this.selectVideo.table.tablePagination.pageSize,
        name: this.selectVideo.form.name,
        firstAbilityId: this.selectVideo.form.firstAbilityId,
        ContentType: 4,
        ScientificName: '游戏指导',
      }
      this.selectVideo.table.tableLoading = true
      this.$http.EGamegelist(params).then((res) => {
        this.selectVideo.table.tableLoading = false
        const { data } = res.data
        this.selectVideo.table.tableDataSource = data.items.map((m) => ({
          ...m,
          firstAbilityName: m.abilitys.length ? m.abilitys[0].firstAbilityName : '',
        }))
        this.selectVideo.table.tablePagination.total = data.totalCount
        this.selectVideo.table.tablePagination.current = data.pageIndex
      })
    },
    StatusChange(record) {
      this.$message.destroy()
      const fn = () => {
        let formData = new FormData()
        formData.append('id', record.id)
        this.loading = true
        this.$http.updatestatus(formData).then(() => {
          this.loading = false
          record.enabled = !record.enabled
          this.$message.success('修改成功')
        })
      }
      if (record.enabled) {
        this.$confirm({
          title: `确认禁用【${record.contentName}】`,
          content: '题目壳禁用后，已配置的课程将移除该题目壳且不可恢复，请谨慎操作',
          centered: true,
          onOk: fn,
        })
        return
      }
      let formData = new FormData()
      formData.append('id', record.id)
      formData.append('enabled', false)
      this.loading = true
      this.$http.contentCheckStatus(formData).then(() => {
        fn()
      })
    },
    onChange(value) {
      console.log(value)
      this.search.AbilityTypeId = value[0]
      this.search.FirstAbilityId = value[1]
      this.search.SecondAbilityId = value[2]
      this.selectId = value
    },
    onChangequestionSet(value) {
      this.questionSet.AbilityTypeId = value[0]
      this.questionSet.FirstAbilityId = value[1]
      this.questionSet.SecondAbilityId = value[2]
      this.selectquestionSetId = value
    },
    loadData(selectedOptions) {
      return new Promise((resolve, reject) => {
        const targetOption = selectedOptions[selectedOptions.length - 1]
        targetOption.loading = true
        targetOption.children = []
        let params = {
          pid: targetOption.id,
          // abilityType: 0,
        }
        this.$http.abilitySelect(params).then((res) => {
          targetOption.loading = false
          targetOption.children = res.data.data.map((m) => ({ ...m, value: m.id, label: m.name, isLeaf: m.levelNumber > 1 }))
          this.options = [...this.options]
          resolve(targetOption.children)
        })
      })
    },
    abilityTypeSelect(level) {
      let params = {
        level: level,
        // abilityType: 0,
      }
      this.$http.abilitySelect(params).then((res) => {
        this.options = res.data.data
        this.options.forEach((item) => {
          item.value = item.id
          item.label = item.name
          item.isLeaf = false
        })
        if (this.search.AbilityTypeId) {
          this.loadData(this.options.filter((f) => f.id === this.search.AbilityTypeId)).then((data) => {
            if (this.search.FirstAbilityId) {
              this.loadData(data.filter((f) => f.id === this.search.FirstAbilityId))
            }
          })
        }
      })
    },
    addEgame() {
      this.$store.commit('content/setQuestionGroupInfo', '')
      this.$router.push({
        path: this.settingPath,
        query: {
          type: 'add',
          contentType: this.search.ContentType,
        },
      })
    },
    edit(record) {
      this.$store.commit('content/setQuestionGroupInfo', { fullPath: this.$route.fullPath, contentType: this.search.ContentType, ...record })
      sessionStorage.setItem('currentId', record.id) //id
      sessionStorage.setItem('currentName', record.contentName) //name
      sessionStorage.setItem('currentRecord', JSON.stringify(record)) //name
      this.$router.push({
        path: this.settingPath,
        query: {
          type: 'edit',
          contentType: this.search.ContentType,
          contentName: record.contentName,
          versionName: record.versionName,
        },
      })
    },
    toNormSetting(item, ability) {
      sessionStorage.setItem('currentName', item.contentName)
      this.$store.commit('content/setQuestionGroupInfo', { fullPath: this.$route.fullPath, ...item })
      const version = item.versions.filter((f) => f.enabled)[0] || {}
      this.$router.push({
        path: '/content/NormSeting/NormComputeDetail',
        query: {
          activeKey: 1,
          type: 'question',
          id: ability.id,
          version: version.version,
          ContentAlgorithmCodeConfigId: ability.codeBindId,
          abilityId: ability.abilityTypeId,
          recordId: ability.normId,
          pegetype: 'apply',
        },
      })
    },
    // 题目设置
    question(record) {
      this.$store.commit('content/setQuestionGroupInfo', { fullPath: this.$route.fullPath, contentType: this.search.ContentType, ...record })
      this.isQuestion = true
      this.modalLoading = true
      this.$router.push({
        query: {
          questionGroupId: record.id,
          ...this.$route.query,
        },
      })
      this.questionGroupId = record.id
      this._contentName = record.contentName
      this.getQuestionSetList('question')
      this.getQuestionsList()
    },
    getQuestionSetList(type) {
      let params = {
        pageIndex: this.modal.pageIndex,
        pageSize: this.modal.pageSize,
        questionGroupId: this.questionGroupId,
      }
      this.$http.getquestionbyidlist(params).then((res) => {
        this.modalLoading = false
        if (type == 'question') {
          this.modalData = res.data.data.items
          this.modal.total = res.data.data.totalCount
        }
        if (type == 'set') {
          this.jumpSetData = res.data.data.items
          this.jumpSet.total = res.data.data.totalCount
        }
      })
    },
    handleCancel() {
      this.selectId = []
      this.currentTab = '1'
      this.isQuestion = false
    },
    // 切换tab
    changeTabs(key) {
      this.questionSetSelect = []
      if (key == 1) {
        this.getQuestionSetList()
      } else if (key == 2) {
        this.getQuestionsList()
      }
    },
    // 新建题目
    addQuestion() {
      this.$store.commit('content/setQuestionInfo', { routerName: '题目壳管理', fullPath: this.$route.fullPath })
      this.$router.push({
        path: '/content/Question/QuestionSeting',
        query: {
          type: 'add',
          questionGroupId: this.questionGroupId,
        },
      })
    },
    // 编辑题目
    editQuestion(record) {
      sessionStorage.setItem('editquestion', record.questionDto.id)
      sessionStorage.setItem('editquestionModal', JSON.stringify(record))
      this.$store.commit('content/setQuestionInfo', { routerName: '题目壳管理', fullPath: this.$route.fullPath, ...record })
      this.$router.push({
        path: '/content/Question/QuestionSeting',
        query: {
          id: record.questionDto.id,
        },
      })
    },
    jumpFun(record) {
      this.isJump = true
      this.isQuestion = false
      this.jumpStr = record.questionDto
      this.questionId = record.questionId
      this.getOptionsList()
    },
    getOptionsList() {
      let params = {
        pageIndex: this.jump.pageIndex,
        pageSize: this.jump.pageSize,
        questionGroupId: this.questionGroupId,
        questionId: this.questionId,
      }
      this.$http.getquestionitemsbyid(params).then((res) => {
        this.jumpData = res.data.data.items
        this.jumpTotal = res.data.data.totalCount
      })
    },
    // 关闭跳转
    CancelJump() {
      this.isJump = false
      this.isQuestion = true
      this.getQuestionSetList('question')
    },
    // 设置
    set(record) {
      this.isJumpSet = true
      this.isJump = false
      this.QuestionItemId = record.id
      this.skipId = record.skipId
      if (record.skipQuestionNo && record.skipQuestionId) {
        this.skipQuestionId = record.skipQuestionId
        sessionStorage.setItem('skipQuestionId', this.skipQuestionId)
      } else {
        this.skipQuestionId = ''
      }

      this.getQuestionSetList('set')
    },
    // 删除设置
    deleteSet(record) {
      console.log(record)
      let formData = new FormData()
      formData.append('id', record.skipId)
      this.$http.deleteskip(formData).then((res) => {
        this.$message.success('删除成功')
        sessionStorage.removeItem('skipQuestionId')
        this.radioIndex = -1
        this.getOptionsList()
      })
    },
    // 关闭设置
    CanceljumpSet() {
      this.isJumpSet = false
      this.isJump = true
      //   this.skipQuestionId =  sessionStorage.getItem('skipQuestionId')
      this.skipQuestionId = ''
      this.radioIndex = -1
      this.jumpSetParams = {}
    },
    // 点击单选
    changeRadio(index, record) {
      console.log(record)
      this.skipQuestionId = -9999
      this.radioIndex = record.id
      this.jumpSetParams = {
        QuestionGroupId: record.questionGroupId,
        QuestionId: this.questionId,
        QuestionItemId: this.QuestionItemId,
        SkipQuestionId: record.questionId,
        Id: this.skipId == 0 ? '' : this.skipId,
      }
      // this.subJumpSet(params)
    },
    // 保存跳转设置
    subJumpSet() {
      let formData = new FormData()
      for (let key in this.jumpSetParams) {
        formData.append(key, this.jumpSetParams[key])
      }
      this.$http.editskip(formData).then((res) => {
        this.$message.destroy()
        this.$message.success(res.data.message)
        this.isJumpSet = false
        this.isJump = true
        this.getOptionsList()
      })
    },
    // 排序
    tableInputBlurDisplayOrder(e, record) {
      let formData = new FormData()
      formData.append('id', record.id)
      formData.append('displayOrder', e.target.value)
      this.$http.updateorder(formData).then((res) => {
        this.$message.success('操作成功')
        this.getQuestionSetList('question')
      })
    },
    // 自动排序
    automaticsorting() {
      let formData = new FormData()
      formData.append('id', this.questionGroupId)
      this.$http.automaticsorting(formData).then((res) => {
        this.$message.success('操作成功')
        this.getQuestionSetList('question')
      })
    },
    // 删除
    deletequertionconfig(record) {
      let query = [record.id]
      this.$http.deletequertionconfig(query).then((res) => {
        this.$message.success('删除成功')
        // 判断是否是第一页，和删除后是否本页还有数据
        if (this.modalData.length == 1 && this.modal.pageIndex != 1) {
          this.modal.pageIndex -= 1
        }
        this.getQuestionSetList('question')
      })
    },
    // 批量删除
    batchDelete() {
      let _this = this
      if (!_this.deleteList.length) {
        this.$message.destroy()
        this.$message.warning('请选择')
        return
      }
      this.$confirm({
        title: '确认删除题目',
        content: `一共选中 ${_this.deleteList.length} 个题目，确定删除？`,
        centered: true,
        onOk() {
          _this.batchDeleteFun()
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    // 批量删除方法
    batchDeleteFun() {
      let arr = []
      this.deleteList.forEach((el, index) => {
        let item = JSON.parse(el)
        arr.push(item.id)
      })
      this.$http.deletequertionconfig(arr).then((res) => {
        this.$message.success('删除成功')
        // 判断是否是第一页，和删除后是否本页还有数据
        if (this.modalData.length == this.deleteList.length && this.modal.pageIndex != 1) {
          this.modal.pageIndex -= 1
        }
        this.getQuestionSetList('question')
        this.deleteList = []
        this.conselectedRows = []
      })
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload(file) {
      const bool = this.fileList.filter((v) => v.name === file.name).length
      if (bool) {
        this.$message.warning('已有相同的文件，请重新选择文件')
        return false
      }
      this.fileList = [file]
      return false
    },
    unploadChange(value) {
      if (value.fileList.length) {
        this.file = value.file
      } else {
        this.file = ''
      }
    },
    openImport() {
      this.isimport = true
    },
    cancelimportOk() {
      this.isimport = false
    },
    // 批量导入提交
    importOk() {
      if (this.file) {
        this.importOkloading = true
        const formData = new FormData()
        formData.append('excelfile', this.file)
        formData.append('QuestionGroupId', this.questionGroupId)
        this.upload(formData)
      } else {
        this.$message.destroy()
        this.$message.warning('请选择xlsx文件')
      }
    },
    upload(formData) {
      this.$http
        .questionsImport(formData)
        .then((res) => {
          this.isimport = false
          this.$message.success(res.message)
          this.getQuestionSetList('question')
          this.fileList = []
          this.file = ''
          this.resetForm()
        })
        .catch((e) => {
          if (e.errors) {
            this.errorData = e.errors
            this.getQuestionSetList('question')
          }
        })
        .finally(() => {
          this.importOkloading = false
        })
    },
    // 下载错误原因
    down() {
      const merges = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 10 } }]
      let titleList1 = ['题目', '', '', '', '', '', '', '', '', '', '']
      let titleList2 = ['题目名称', '题目分组', '题目类型', '题目版本', '题目难度系数', '题目能力类型', '题目一级能力', '题目二级能力', '题目备注说明', '题目解析', '题目附件']
      const list = this.errorData.map((m, i) => {
        let data = [
          m.name,
          m.questionGroup,
          this.$data._questionType[m.questionType],
          m.version,
          m.degreeOfDifficultyText,
          m.abilityTopText,
          m.firstAbilityText,
          m.secondAbilityText,
          m.remark,
          m.analysis,
          m.attachmentUrl,
        ]
        m.questionItems.forEach((f, i2) => {
          data = data.concat([f.itemTitle, f.scoreText, f.isRightChoiceText, f.displayOrderText, f.jumpQuestionNOText, f.itemAttachmentUrl])
          if (i === 0) {
            merges.push({ s: { r: 0, c: 10 + i2 * 6 + 1 }, e: { r: 0, c: 10 + (i2 + 1) * 6 } })
            titleList1 = titleList1.concat(['选项' + (i2 + 1), '', '', '', '', ''])
            titleList2 = titleList2.concat(['选项标题', '选项分值', '是否正确答案', '显示顺序', '跳转题目编号', '选项附件'])
          }
        })
        data.push(m.messageList.join('\n'))
        return data
      })
      // 添加错误信息列
      titleList1.push('错误信息')
      titleList2.push('')
      merges.push({ s: { r: 0, c: titleList2.length - 1 }, e: { r: 1, c: titleList2.length - 1 } })
      // 创建一个新的工作簿
      const workbook = XLSX.utils.book_new()
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet([titleList1, titleList2].concat(list))
      const cols = []
      // 设置内容样式
      Object.keys(worksheet).forEach((f) => {
        if (typeof worksheet[f] !== 'object') {
          return
        }
        worksheet[f].s = {
          font: {
            sz: 12,
            color: { rgb: '000000' },
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        }
      })
      // 设置表头样式
      titleList2.forEach((f, i) => {
        const ex0 = XLSX.utils.encode_cell({ r: 0, c: i })
        const ex1 = XLSX.utils.encode_cell({ r: 1, c: i })
        const obj = {
          font: {
            sz: 12,
            bold: true,
            color: { rgb: worksheet[ex0].v === '错误信息' ? 'FF0000' : '000000' },
          },
          fill: {
            fgColor: { rgb: 'eeeeeeff' }, // 背景
          },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } }, // 上边框
            bottom: { style: 'thin', color: { rgb: '000000' } }, // 下边框
            left: { style: 'thin', color: { rgb: '000000' } }, // 左边框
            right: { style: 'thin', color: { rgb: '000000' } }, // 右边框
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        }
        worksheet[ex0].s = obj
        worksheet[ex1].s = obj
        // 设置列宽
        cols.push({ wpx: worksheet[ex0].v === '错误信息' ? 250 : 120 })
      })
      // 设置列宽
      worksheet['!cols'] = cols
      // 设置行高
      worksheet['!rows'] = list.map((m) => ({ hpt: 23 }))
      // 设置合并单元格
      worksheet['!merges'] = merges
      // 将工作表添加到工作簿中
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
      // 将工作簿导出为 Excel 文件
      XLSX.writeFile(workbook, '导入题目错误数据.xlsx')
    },
    // 题目配置列表
    getQuestionsList(query) {
      let params = {
        AbilityTypeId: this.search.AbilityTypeId,
        FirstAbilityId: this.search.FirstAbilityId,
        SecondAbilityId: this.search.SecondAbilityId,
      }
      if (query) {
        this.questionSet.pageIndex = 1
        params = {}
      }
      this.questionSet.groupId = this.questionGroupId
      for (let key in this.questionSet) {
        if (this.questionSet[key]) {
          params[key] = this.questionSet[key]
        }
      }
      this.$http.questionsList(params).then((res) => {
        this.questionSetData = res.data.data.items
        this.questionSetTotal = res.data.data.totalCount
      })
    },
    questionSetAdd() {
      let _this = this
      if (!_this.addList.length) {
        this.$message.destroy()
        this.$message.warning('请选择题目')
        return
      }
      this.$confirm({
        title: '提示',
        content: `一共选中 ${_this.addList.length} 个题目，确定添加？`,
        onOk() {
          _this.addFun()
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    addFun() {
      let formData = new FormData()
      let str = {
        displayOrder: '',
        questionGroupId: '',
        questionId: '',
      }
      this.addList.forEach((el, index) => {
        let item = JSON.parse(el)
        item.questionGroupId = this.questionGroupId
        item.questionId = item.id
        item.displayOrder = 0
        for (let key in item) {
          for (let k in str) {
            if (key == k) {
              formData.append(`models[${index}][${key}]`, item[key])
            }
          }
        }
      })
      this.$http.addquestionconfig(formData).then((res) => {
        this.$message.success('添加成功')
        this.modal.pageIndex = 1
        this.questionSet.pageIndex = 1
        this.getQuestionSetList('question')
        this.getQuestionsList()
        this.addList = []
        this.questionSetSelect = []
      })
    },

    getList(pageIndex) {
      if (pageIndex) {
        this.search.PageIndex = pageIndex
      }
      this.setQuery()
      this.tableExpandedRowKeys = []
      this.$http.questiongrouppagelist(this.search).then((res) => {
        console.log(res)
        this.dataSource = res.data.data.items.map((v) => ({
          ...v,
          childTableData: [],
          childTableLoading: false,
        }))
        this.total = res.data.data.totalCount
        this.loading = false
      })
    },
    getVersion(expanded, record) {
      if (expanded) {
        let params = {
          id: record.id,
        }
        record.childTableLoading = true
        this.$http.EGamegeVersion(params).then((res) => {
          record.childTableLoading = false
          record.childTableData = res.data.data
        })
      }
    },
    deleteEgame(record) {
      this.$confirm({
        title: `确认删除【${record.contentName}】`,
        content: '题目壳删除后所有相关数据都将删除且不可恢复，请谨慎操作',
        centered: true,
        onOk: () => {
          let formData = new FormData()
          formData.append('contentId', record.id)
          this.loading = true
          this.$http.deleteEGamege(formData).then((res) => {
            this.loading = false
            this.getList(1)
            this.$message.success('删除成功')
          })
        },
      })
    },
    onPageChange(pageIndex, size) {
      this.search.PageIndex = pageIndex
      this.tableExpandedRowKeys = []
      this.innerData = []
      this.getList()
    },
    onSizeChange(pageIndex, size) {
      this.search.PageIndex = 1
      this.search.PageSize = size
      this.tableExpandedRowKeys = []
      this.innerData = []
      this.getList()
    },
    onModalChange(pageIndex, size) {
      this.modal.pageIndex = pageIndex
      this.getQuestionSetList('question')
    },
    onModalSizeChange(pageIndex, size) {
      this.modal.pageIndex = 1
      this.modal.pageSize = size
      this.getQuestionSetList('question')
    },
    onjumpChange(pageIndex, size) {
      this.jump.pageIndex = pageIndex
      this.getOptionsList()
    },
    onjumpSizeChange(pageIndex, size) {
      this.jump.pageIndex = 1
      this.jump.pageSize = size
      this.getOptionsList()
    },
    onjumpSetChange(pageIndex, size) {
      this.modal.pageIndex = pageIndex
      this.getQuestionSetList('set')
    },
    onjumpSetSizeChange(pageIndex, size) {
      this.modal.pageIndex = 1
      this.modal.pageSize = size
      this.getQuestionSetList('set')
    },
    onquestionSetChange(pageIndex, size) {
      this.questionSet.pageIndex = pageIndex
      this.getQuestionsList()
    },
    onquestionSetSizeChange(pageIndex, size) {
      this.questionSet.pageIndex = 1
      this.questionSet.pageSize = size
      this.getQuestionsList()
    },
    resetSearch() {
      this.search = {
        ...this.search,
        PageIndex: 1,
        PageSize: 10,
        Name: '',
        versionName: undefined,
        AbilityTypeId: '',
        FirstAbilityId: '',
        SecondAbilityId: '',
        Enabled: undefined,
        minAge: undefined,
        maxAge: undefined,
      }
      this.selectId = []
      this.getList()
    },
  },
}
</script>

<style scoped>
.Questiongroup >>> .standard-table .alert {
  display: none !important;
}

.Questiongroup >>> .searchForm {
  display: flex;
}

.Questiongroup >>> .searchForm .fold {
  width: 91%;
  display: flex;
}
</style>
<style lang="less" scoped>
.table_div {
  display: flex;
  align-items: center;
}
.table_icon {
  color: #ff9904;
  font-size: 24px;
  margin-right: 5px;
}
/deep/ .ant-table-tbody .testClass {
  padding: 0 !important;
}

.self_td {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
}

.name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.noClick {
  color: #ccc;
  cursor: not-allowed;
}

.jumptop {
  width: 100%;
  padding: 15px 15px 0 15px;
  background: #f2f2f2;
  display: flex;
  justify-content: space-around;
  margin-bottom: 15px;

  .j_t_item {
    ul {
      margin: 0;

      li {
        list-style: none;
        margin-bottom: 15px;

        em {
          font-style: normal;
        }
      }
    }
  }
}

.subBtn {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.m_search {
  padding-left: 30px;
}

.viewUl {
  padding: 0;
  border: 1px solid #e6e6e6;
  border-top: 0;

  li {
    list-style: none;
    border-top: 1px solid #e6e6e6;
    display: flex;
    align-items: center;
    padding: 5px 15px;
    min-height: 53px;

    span {
      margin: 0 30px;
    }

    img {
      margin-left: 100px;
      width: 100px;
    }
  }

  .viewpick {
    background: #f2f2f2;
  }

  .bot_t {
    display: flex;
    background: #f2f2f2;

    li {
      flex: 1 1 0;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 1px solid #e6e6e6;
      min-height: 53px;

      span {
        margin: 0;
      }
    }

    li:last-child {
      border-right: 0;
    }
  }

  .bot_b {
    li {
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 53px;

      span {
        min-height: 53px;
        display: flex;
        margin: 0;
        flex: 1 1 0;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #e6e6e6;
      }

      span:last-child {
        border-right: 0;
      }
    }
  }
}

.table-input {
  border: none;
  width: 100%;
  height: 100%;
  display: block;
  background: transparent;
  outline: none;
  text-align: center;
}

input[type='number'] {
  -moz-appearance: textfield;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.dImg {
  width: 100%;
}

.top img {
  max-width: 100%;
}

.qusetion-box {
  height: 500px;
  overflow-y: auto;
}
</style>
